export default __webpack_public_path__ + "static/media/saveIcon.793b8660.svg";